import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { valueFromEvent } from 'lib/util';
import {
  clearSubcompany,
  getSubcompany,
  modifySubcompany,
  saveSubcompany,
} from 'subcompanies/actions';

import { addGrowlError, addGrowlSuccess } from 'messages/actions';
import * as Common from 'common/components';
import * as Subcompanies from 'subcompanies/components';

import { getCompany } from 'auth/selectors';
import {
  getIsSaving,
  getIsFetching,
  getSubcompany as getEditingSubcompany,
} from 'subcompanies/selectors';

class SubcompanyFormContainer extends PureComponent {
  state = { isValid: false, isSubmitted: false };

  componentWillMount = () => {
    this.props.clearSubcompany();
    const { subcompanyId } = this.props.match.params;
    if (subcompanyId) this.props.getSubcompany(this.props.company.id, subcompanyId);
  };

  handleValueChange = (e) => this.props.modifySubcompany(valueFromEvent(e));

  handleValidation = (isValid, message) => this.setState({ isValid });

  handleSubmit = ({ isValid }) =>
    this.setState({ isSubmitted: true }, () => {
      if (!isValid) {
        return this.props.addGrowlError('error.verify');
      }

      this.props
        .saveSubcompany(this.props.company.id, this.props.subcompany)
        .then(({ value }) => {
          this.props.addGrowlSuccess(value.message);
          this.props.history.push(`/companies/${this.props.company.id}`);
        })
        .catch((err) => err.code !== 401 && this.props.addGrowlError(err.message));
    });

  getFormTitle = () =>
    this.props.t(
      this.props.subcompany.id ? 'subcompanies.form_edit_title' : 'subcompanies.form_add_title'
    );

  getFormIcon = () => (this.props.subcompany.id ? 'pencil-square-o' : 'plus-circle');

  render = () => {
    return (
      <Common.Wrapper fluid={true}>
        <Common.Header title={this.props.t('subcompanies.title')} />
        <div className="col-12">
          <Common.Portlet title={this.getFormTitle()} icon={this.getFormIcon()}>
            <Subcompanies.Form
              companyId={this.props.company.id}
              handleSubmit={this.handleSubmit}
              handleValidation={this.handleValidation}
              handleValueChange={this.handleValueChange}
              isLoading={this.props.isSaving}
              isFetching={this.props.isFetching}
              isSubmitted={this.state.isSubmitted}
              values={this.props.subcompany}
            />
            <Common.LoaderOverlay show={this.props.isFetching} />
          </Common.Portlet>
        </div>
      </Common.Wrapper>
    );
  };
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getEditingSubcompany(state),
  isFetching: getIsFetching(state),
  isSaving: getIsSaving(state),
});

const mapDispatchToProps = {
  addGrowlError,
  addGrowlSuccess,
  clearSubcompany,
  getSubcompany,
  modifySubcompany,
  saveSubcompany,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(withRouter(SubcompanyFormContainer)));



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/containers/SubcompanyFormContainer.js